export const urlConst = {
    MAIN: '',
    PROFILE: '/profile',
    REQUESTS: 'requests',
    NEW_REQUEST: 'new-request',
    PROGRAM: 'program',
    PROGRAM_REQUEST: '/program/request/:reqNum',
    LOGIN: '/login',
    LOGOUT: '/login',
    REGISTRATION: '/signup',
    RESET_PASS: '/reset-password',
    MESSAGE: '/message/:messCode',

    API_USER_AUTH: '/api/user/auth',
    API_USER_AUTH_BY_VK: '/api/user/auth_by_vk',
    API_USER_CREATE: '/api/user/create',
    API_USER_UPDATE: '/api/user/update',
    API_USER_LOGOUT: '/api/user/logout',
    API_USER_GET: '/api/user/getMyself',
    API_RESET_PASS: '/api/user/send_pass_email',

    API_GET_CATEGORIES: '/api/dictionary/category/list',
    API_GET_REQUESTS: '/api/request/list',
    API_ADD_REQUEST: '/api/request/add',
    API_UPDATE_REQUEST_FIELD: '/api/request/update_field',
    API_ADD_REQUEST_USER: '/api/request/user',
    API_DEL_REQUEST_USER: '/api/request/user',
    API_UPDATE_REQUEST_USER: '/api/request/user',
    API_ADD_REQUEST_COMMENT: '/api/request/comment',
    API_READ_REQUEST_COMMENT: '/api/request/comment/{commentId}/read',
    API_ADD_REQUEST_FILE: '/api/request/file',
    API_DEL_REQUEST_FILE: '/api/request/file',
    API_GET_REQUEST_FILE: '/api/request/file',
    API_BIND_REQUEST_FILE: '/api/request/file/bind',
    API_SAVE_EXT_DATA: '/api/request/extData',
    API_ADD_REQUEST_FILE_LINK: '/api/request/link',
    API_ADD_REQUEST_FILE_THUMBNAIL: '/api/request/thumbnail',

    API_GET_EVENTS: '/api/dictionary/event/list',
    API_GET_PROGRAM: '/api/program',
    API_GET_CLIENT_VOICES: '/api/voice',
    API_SET_CLIENT_VOICE: '/api/voice',
    API_APPROVE_CLIENT: '/api/voice/approveClient',

    API_MOVE_REQUEST: '/api/request/move',
};
